import { useState } from 'react'
import { Typography, Paper } from '@mui/material'
import PropTypes from 'prop-types'
import CurveFormFields from './CurveFormFields'

const defaultSegment = () => ({
  segmentOrder: '',
  startKnot: '',
  endKnot: '',
  segmentType: 'polynomial',
  terms: [],
  a: '',
  b: '',
  c: '',
})

const CurveCreateForm = ({ onSubmit }) => {
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [appliesTo, setAppliesTo] = useState('target')
  const active = true
  const [segments, setSegments] = useState([])

  const handleSegmentChange = (index, field, value) => {
    const updated = [...segments]
    updated[index][field] = value
    setSegments(updated)
  }

  const handleTermChange = (segmentIndex, termIndex, field, value) => {
    const updated = [...segments]
    updated[segmentIndex].terms[termIndex][field] = value
    setSegments(updated)
  }

  const addSegment = () => setSegments([...segments, defaultSegment()])

  const removeSegment = (index) => {
    const updated = [...segments]
    updated.splice(index, 1)
    setSegments(updated)
  }

  const addTerm = (index) => {
    const updated = [...segments]
    updated[index].terms.push({ power: '', coefficient: '' })
    setSegments(updated)
  }

  const removeTerm = (segmentIndex, termIndex) => {
    const updated = [...segments]
    updated[segmentIndex].terms.splice(termIndex, 1)
    setSegments(updated)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const payload = {
      name,
      description,
      appliesTo,
      active,
      segments,
    }
    onSubmit(payload)
  }

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        Create New Curve
      </Typography>
      <CurveFormFields
        type="create"
        name={name}
        setName={setName}
        description={description}
        setDescription={setDescription}
        appliesTo={appliesTo}
        setAppliesTo={setAppliesTo}
        active={active}
        setActive={() => {}}
        segments={segments}
        handleSegmentChange={handleSegmentChange}
        handleTermChange={handleTermChange}
        handleAddSegment={addSegment}
        handleRemoveSegment={removeSegment}
        handleAddTerm={addTerm}
        handleRemoveTerm={removeTerm}
        handleSubmit={handleSubmit}
      />
    </Paper>
  )
}

CurveCreateForm.propTypes = {
  initialData: PropTypes.any,
  onSubmit: PropTypes.func.isRequired,
}

export default CurveCreateForm
